import $ from 'jquery';
import 'jquery-nice-select/js/jquery.nice-select';
import 'jquery-nice-select/js/prism';
import 'jquery-nice-select/js/fastclick.js';

export function loadCustomSelect(){
    $('.nrn_custom_select[data-loaded="false"]').niceSelect();
    $('.nrn_custom_select[data-loaded="false"] + .nice-select').append('<i class="fa fa-chevron-down"></i>');
    $('.nrn_custom_select[data-loaded="false"]').data('loaded', 'true');
}

export function initCustomSelectClickHandler() {
    $('.nrn_custom_select[data-loaded="false"]').closest('.fs__dropdown').on('click', (e) => {
        // $(e.currentTarget).find('.nice-select.nrn_custom_select').click();
    });
}
